import { useCallback, useEffect, useState } from "react";
import {
  PageInfo,
  RegisterableConnection,
  Registration,
} from "../generated/lmsTypes";
import { GET_EXISTING_REGISTRATIONS } from "../queries/privateTraining";
import { useLmsClient } from "./lms";

export const useAlreadyRegisteredEventIds = () => {
  const client = useLmsClient();
  const [loading, setLoading] = useState(true);
  const [registeredEventIds, setRegisteredEventIds] = useState<string[]>([]);
  const fetchAllRegisteredEventIds = useCallback(
    async (forceRefetch = false) => {
      setLoading(true);
      const eventIds: string[] = [];
      let pageInfo: PageInfo | null = null;
      while (!pageInfo || pageInfo.hasNextPage) {
        const response: { data: { registerables: RegisterableConnection } } =
          await client.query({
            query: GET_EXISTING_REGISTRATIONS,
            variables: { cursor: pageInfo ? pageInfo.endCursor : undefined },
            fetchPolicy: forceRefetch ? "network-only" : undefined,
          });
        response.data.registerables.edges.forEach(edge => {
          const courseId = (edge?.node as Registration)?.course?.id;
          if (courseId) {
            eventIds.push(courseId);
          }
        });
        pageInfo = response.data.registerables.pageInfo!;
      }
      setRegisteredEventIds(eventIds);
      setLoading(false);
    },
    [client],
  );
  useEffect(() => {
    fetchAllRegisteredEventIds();
  }, [fetchAllRegisteredEventIds]);
  return {
    loading,
    registeredEventIds,
    refetch: () => fetchAllRegisteredEventIds(true),
  };
};
